import React from 'react';
import {Dialog} from '@headlessui/react'
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline'
import useModalStore from "../store/modal";
import Verify2FA from "./Verify2FA";
import TextInput from "./TextInput";
import Button from "./Button";
import Loading from "./Loading";

function ConfirmationModal() {
    const {
        isVisible,
        title,
        description,
        onConfirm,
        onCancel,
        clearModal,
        hideModal,
        otpValue,
        setOtpValue,
        confirmText,
        otpRequired
    } = useModalStore();
    if (!isVisible) return null;

    const handleYes = () => {
        if (otpRequired && !otpValue) return;

        if (onConfirm) onConfirm();
        clearModal();
    };

    const handleNo = () => {
        if (onCancel) onCancel();
        clearModal();
    };

    return (
        <Dialog open={isVisible} onClose={handleNo} className="relative z-50">
            <Dialog.Overlay
                transition
                className="fixed inset-0 bg-gray-500/75 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                    <Dialog.Panel
                        transition
                        className="relative transform overflow-hidden rounded-xl bg-white text-left shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:size-10">
                                    <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-blue-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ltr:ml-4 sm:rtl:mr-4 sm:mt-0 sm:ltr:text-left sm:rtl:text-right">
                                    <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900">
                                        {title}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-600">
                                            {description}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {otpRequired && <div className="mt-6 w-full max-w-sm mx-auto">
                                <TextInput name="2fa-otp"
                                           label="Enter Two-Factor Authentication Code"
                                           id="2fa-otp" type="text"
                                           get={otpValue}
                                           set={value => {
                                               setOtpValue(value)
                                           }}/>
                            </div>}

                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse gap-3 sm:px-6 border-t border-gray-200">
                            <Button
                                type="button"
                                onClick={handleYes}
                            >
                                {confirmText}
                            </Button>
                            <Button
                                type="button"
                                secondary={true}
                                onClick={handleNo}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Dialog.Panel>
                </div>
            </div>
        </Dialog>
    );

}

export default ConfirmationModal;